import atomize from "@quarkly/atomize";
import { commonTextProps, commonTextPropsDefaults } from "./text";
export default atomize.span({
  name: "Inline",
  inline: true,
  description: {
    en: "inline - child element of text for deep customization",
    ru: "Элемент inline - дочерний элемент текста, для глубокой кастомизации"
  },
  propInfo: commonTextProps
}, commonTextPropsDefaults);